import React, { useEffect, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

const FaceValidation = ({ history }) => {
    const webcamRef = useRef(null);
    const [detectedName, setDetectedName] = useState('');
    const [validationStatus, setValidationStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Function to validate face in real-time
    const detectFace = async () => {
        if (webcamRef.current) {
            const imageSrc = webcamRef.current.getScreenshot();
            if (!imageSrc) {
                return; // Skip if no image is captured
            }

            try {
                const response = await axios.post('/validate_face', {
                    image: imageSrc,
                });

                if (response.data.success) {
                    setDetectedName(response.data.message.replace('Face validated as ', ''));
                } else {
                    setDetectedName('Unknown');
                }
            } catch (error) {
                console.error('Error during face detection:', error);
                setDetectedName('');
            }
        }
    };

    // Start periodic face detection
    useEffect(() => {
        const interval = setInterval(() => {
            detectFace();
        }, 3000); // Adjust the interval (milliseconds) as needed
        return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, []);

    const handleLogin = async () => {
        if (webcamRef.current) {
            const imageSrc = webcamRef.current.getScreenshot();
            if (!imageSrc) {
                setValidationStatus('Failed to capture image. Please try again.');
                return;
            }
            setIsLoading(true);
            try {
                console.log('Sending validation request:', { image: imageSrc });
                const response = await axios.post('/validate_face', {
                    image: imageSrc,
                });

                console.log('Response from backend:', response.data);

                if (response.data.success) {
                    history.push('/hashdocs');
                } else {
                    setValidationStatus(response.data.message || 'Face not recognized.');
                }
            } catch (error) {
                console.error('Error during validation:', error);
                setValidationStatus('Failed to validate face. Please try again.');
            }
            setIsLoading(false);
        }
    };

    return (
        <div>
            <h1>Login Page</h1>
            <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={400}
                height={300}
            />
            {detectedName && (
                <p>
                    Detected: <strong>{detectedName}</strong>
                </p>
            )}
            <button onClick={handleLogin} disabled={isLoading || detectedName === ''}>
                {isLoading ? 'Logging in...' : 'Login'}
            </button>
            {validationStatus && <p>{validationStatus}</p>}
        </div>
    );
};

export default withRouter(FaceValidation);
